import { render, staticRenderFns } from "./newsCont.vue?vue&type=template&id=36f375f2&scoped=true&"
import script from "./newsCont.vue?vue&type=script&lang=js&"
export * from "./newsCont.vue?vue&type=script&lang=js&"
import style0 from "./newsCont.vue?vue&type=style&index=0&id=36f375f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f375f2",
  null
  
)

export default component.exports